import * as React from 'react';
import { ImageStyle, Image as Img } from './Image.style';
import { Loader } from 'react-inv-forms';
import avatarTabela from '../../../../images/avatarTabela.svg';

export interface ImageTableCellTypes {
  type: 'image';
  data: ImageAtributtes;
}
export interface ImageAtributtes {
  url: string;
  name: string;
}
interface Props {
  /** dane zdjęcia - adres url, tytuł */
  data: ImageAtributtes;
}
/**
 * Komponent do rozkodowania i generowania zdjęcia
 *
 */
export default function Image({ data }: Props): JSX.Element {
  return (
    <ImageStyle>
      {
        data ?
          <Img src={`data:image/svg;base64, ${data}`} alt={data.name} loader={<Loader />} />
          : avatarTabela
      }
    </ImageStyle>
  );
}
